import { useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core';
import cx from 'classnames';
import _debounce from 'lodash.debounce';

import { passwordStrengthScore } from '@cloud-wave/neon-common-lib';

import './password-strength-meter.scss';

const UPDATE_SCORE_TIMEOUT_MS = 500;

const useStyles = ({ score }: any) =>
  makeStyles(() => ({
    meter: { width: `${(score / 4) * 100}%` },
  }))();

function PasswordStrengthMeter({ password }: { password?: string }) {
  const [score, setScore] = useState(0);

  const classes = useStyles({ score });

  const updateScore = _debounce(() => {
    setScore(passwordStrengthScore(password));
  }, UPDATE_SCORE_TIMEOUT_MS);

  useEffect(() => {
    if (!password) {
      return void setScore(0);
    }

    updateScore();
  }, [password]);

  return (
    <div className="password-strength-meter">
      <div
        className={cx('password-strength-meter__inner', `password-strength-meter__inner--${score}`, classes.meter)}
      />
    </div>
  );
}

export default PasswordStrengthMeter;
